import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=127a76e6&scoped=true"
import script from "./OnBoarding.vue?vue&type=script&lang=ts"
export * from "./OnBoarding.vue?vue&type=script&lang=ts"
import style0 from "./OnBoarding.vue?vue&type=style&index=0&id=127a76e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a76e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127a76e6')) {
      api.createRecord('127a76e6', component.options)
    } else {
      api.reload('127a76e6', component.options)
    }
    module.hot.accept("./OnBoarding.vue?vue&type=template&id=127a76e6&scoped=true", function () {
      api.rerender('127a76e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/OnBoarding.vue"
export default component.exports